import React from 'react';
import Login from '../../components/Login';

const LoginModule = () => {
    return (
        <div>
            <Login/>
        </div>
    );
};

export default LoginModule;